<template>
	<div class="am-album"
		:class="{ 'is-idle': !init }"
	>
		<div class="am-album__upper swiper-container">
			<div class="am-album__wrapper swiper-wrapper">
				<div
					v-for="(image, index) in images"
					class="am-album__slide swiper-slide"
					:key="`upper-${index}`"
				>
					<div class="am-album__image" :data-src="getSrc(image)">
					</div>
				</div>
			</div>

			<am-text class="am-album__caption" :dark="true" v-if="caption">
				{{ current + 1 }} - {{ caption }}
			</am-text>
		</div>

		<div class="am-album__lower swiper-container">
			<div class="am-album__wrapper swiper-wrapper">
				<div
					v-for="(image, index) in images"
					class="am-album__slide swiper-slide"
					:class="{ 'is-active': index == current }"
					:key="`lower-${index}`"
				>
					<div class="am-album__image" :data-src="getSrc(image)">
					</div>
				</div>
			</div>
		</div>
		
		<am-button-icon
			class="am-team__prev"
			name="arrow-left"
			v-on:click="onPrev"
			v-if="images.length > 1"
		/>
		<am-button-icon
			class="am-team__next"
			name="arrow-right"
			v-on:click="onNext"
			v-if="images.length > 1"
		/>

	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMButtonIcon from '@/components/molecules/AMButtonIcon'
import Swiper from 'swiper'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
		'am-button-icon': AMButtonIcon
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},

		images: {
			type: Array,
			default: () => ([
				'https://placeimg.com/640/480/any',
				'https://placeimg.com/800/600/any',
				'https://placeimg.com/1024/768/any',
				'https://placeimg.com/640/480/nature',
				'https://placeimg.com/800/600/nature',
				'https://placeimg.com/1024/768/nature',
				'https://placeimg.com/640/480/tech',
				'https://placeimg.com/800/600/tech',
				'https://placeimg.com/1024/768/tech',
				'https://placeimg.com/640/480/people',
				'https://placeimg.com/800/600/people',
				'https://placeimg.com/1024/768/people',
				'https://placeimg.com/640/480/any',
				'https://placeimg.com/800/600/any',
				'https://placeimg.com/1024/768/any',
				'https://placeimg.com/640/480/nature',
				'https://placeimg.com/800/600/nature',
				'https://placeimg.com/1024/768/nature'
			])
		}
	},

	computed: {
		current() {
			if (this.upper)
				return this.upper.activeIndex

			return 0
		},

		caption() {
			return this.images[this.current].caption
		}
	},

	mounted() {
		this.initialize()

		if (this.init)
			this.onLoad()
	},

	destroyed() {
		this.destroy()
	},

	watch: {
		init(value) {
			if (value)
				this.onLoad()
		}
	},

	data: () => ({
		upper: null,
		lower: null
	}),

	methods: {
		initialize() {
			this.lower = new Swiper(this.$el.querySelector('.am-album__lower'), {
				slidesPerView: 15,
				slidesPerGroup: 1,
				breakpoints: {
					990: {
						slidesPerView: 10
					},
					768: {
						slidesPerView: 5
					}
				}
			})

			this.upper = new Swiper(this.$el.querySelector('.am-album__upper'), {
				slidesPerView: 1,
				keyboard: {
			        enabled: true
			    },
				thumbs: {
					swiper: this.lower
				}
			})

			this.$nextTick(() => {
				this.upper.update()
				this.lower.update()
			})
		},

		destroy() {
			this.upper.destroy()
			this.lower.destroy()
		},

		onPrev() {
			this.upper.slidePrev()
		},

		onNext() {
			this.upper.slideNext()
		},

		onLoad() {
			let images = this.$el.querySelectorAll('.am-album__image')

			images.forEach(image => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = function() {
					image.style.backgroundImage = `url(${img.src})`
					image.classList.add('is-active')
				}
			})
		},

		getSrc(image) {
			if (typeof image === 'object')
				return image.path
			else
				return image
		}
	}
}
</script>

<style lang="scss">
.am-album{
	min-height: 400px;
	display: flex;
	flex-flow: column;
	overflow: hidden;
	transition: .3s $easeInOutQuad;
	&__slide{
		background-position: center;
		background-size: cover;
	}
	&__upper{
		width: 100%;
		flex: 1;
		&:after{
			content: "";
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 130px;
			z-index: 20;
			background: linear-gradient(
				to bottom,
				rgba(black, 0) 0%,
				rgba(black, .64) 100%
			);
		}
		.am-album{
			&__slide{
			}
		}
	}
	&__lower{
		width: 100%;
		flex-shrink: 0;
		overflow: inherit !important;
		position: relative;
		z-index: 30 !important;
		padding-top: 30px !important;
		margin-top: -30px !important;
		.am-album{
			&__slide{
				transform-origin: 50% 100%;
				transition: .3s $easeInOutQuad;
				cursor: pointer;
				&.is-active{
					transform: scale(1.05);
					z-index: 20;
					box-shadow: 0 0px 15px rgba(black, .6);
					&:before{
						opacity: 1;
					}
				}
				&:before{
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: rgba(white, .5);
					opacity: 0;
					transition: .3s $easeInOutQuad;
				}
				&:after{
					content: "";
					display: block;
					padding-top: 100%;
				}
			}
		}
	}
	&__caption{
		position: absolute;
		bottom: 8px;
		left: 50%;
		font-size: 13px;
		z-index: 30;
		transform: translateX(-50%);
	}
	&__image{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 50%;
		left: 50%;
		opacity: 0;
		transform: translate(-50%, -50%) scale(.8);
		transition: .8s $easeInOutQuad;
		background-position: center;
		background-size: cover;
		&.is-active{
			opacity: 1;
			transform: translate(-50%, -50%) scale(1);
		}
	}

	&.is-idle{
		opacity: 0;
	}
}
</style>
